import { initializeApp } from 'firebase/app';
import {
  GoogleAuthProvider,
  OAuthProvider,
  browserPopupRedirectResolver,
  browserSessionPersistence,
  initializeAuth,
  signInWithPopup,
  signInWithRedirect,
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyDDh7gTncEuw_2R9NV9uc2K9WKMTE4eMf8',
  authDomain:
    process.env.NODE_ENV === 'production'
      ? window.location.host
      : 'mytraits.ai',
  projectId: 'origene-project',
  storageBucket: 'origene-project.firebasestorage.app',
  messagingSenderId: '563474483558',
  appId: '1:563474483558:web:890f44af5bd95a697aa0a7',
  measurementId: 'G-HGVWEND15F',
};

const app = initializeApp(firebaseConfig);

export const firebaseAuth = initializeAuth(app, {
  persistence: browserSessionPersistence,
  popupRedirectResolver: browserPopupRedirectResolver,
});

async function signInWithRedirectToApp(provider: any) {
  if (process.env.NODE_ENV === 'development') {
    return signInWithPopup(firebaseAuth, provider).catch(error => {
      console.error('firebase sign in error', error);
    });
  }
  return signInWithRedirect(firebaseAuth, provider).catch(error => {
    console.error('firebase sign in error', error);
  });
}

export const signInWithGoogle = async () => {
  try {
    const provider = new GoogleAuthProvider();
    provider.addScope('profile');
    provider.addScope('email');
    provider.setCustomParameters({ prompt: 'select_account' });
    return await signInWithRedirectToApp(provider);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const signInWithApple = async () => {
  try {
    const provider = new OAuthProvider('apple.com');
    provider.addScope('email');
    provider.addScope('name');
    return await signInWithRedirectToApp(provider);
  } catch (err) {
    return Promise.reject(err);
  }
};
